/**
 * @desc centerId查询映射关系，公开方法
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<string>;
export function request(centerId: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/centerCountyMapping/public/centerCounty/selectByCenterId/${centerId}`, {
      method: "GET",

      ...options,
    }),
  );
}
